var React = require('react');

function BackSmallInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd","stroke":"currentColor","strokeLinejoin":"round","strokeWidth":"1.4","transform":"translate(3 5)"},[React.createElement("polyline",{"points":"6.908 11.969 .7 6.241 6.908 .514","key":0}),React.createElement("path",{"d":"M.7 6.242h13.021a2.755 2.755 0 0 1 2.755 2.755v2.25","key":1})]));
}

BackSmallInline.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = BackSmallInline;

BackSmallInline.default = BackSmallInline;
